// eslint-disable-next-line import/prefer-default-export
export const MODAL_SHARE = 'modal_share' as const;

export type ModalType = typeof MODAL_SHARE;
